<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      @keyup.enter.native="submit('verificationCode')"
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="phone">
        <!-- 手机号码 -->
        <div class="input-custom-disabled">
          +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
        </div>
      </el-form-item>
      <el-form-item class="form-item-primary" prop="verification_code">
        <BaseInput
          v-model="form.verification_code"
          :maxlength="smsLength"
          @focus="changeCode"
          :validate-event="Boolean(form.verification_code)"
          :placeholer="$t('login.loginPage.verificationCode')"
        >
          <template #btn>
            <VerificationCode
              ref="verification"
              @click="sendCode"
              :account="form.phone"
              :from="'login'"
            />
          </template>
          <template #prefix>{{
            $t('login.loginPage.verificationCode')
          }}</template>
        </BaseInput>
      </el-form-item>
      <el-form-item>
        <p class="red-word" @click="changeLoginType">
          {{ $t('login.loginPage.signInWithPassword') }}
        </p>
      </el-form-item>
    </el-form>

    <el-button
      class="button-custom"
      @click="submit('verificationCode')"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.signIn`,
      }"
      >{{ $t('login.loginPage.signIn') }}</el-button
    >
  </div>
</template>

<script>
import LoginByPhoneMixin from './../mixins/LoginByPhoneMixin'
import store from '@/store'
export default {
  mixins: [LoginByPhoneMixin],
  data() {
    return {
      isWrong: false,
    }
  },
  computed: {
    smsLength() {
      return store.state.smsLength
    }
  },

  created() {},

  methods: {
    changeCode() {
      this.isWrong = false
    },
    changeLoginType() {
      this.$emit('changeLoginType', 'password')
    },
  },
}
</script>
<style lang="scss" scoped>
.login-btn-default {
  margin-top: 8px;
}
.form-custom {
  margin-top: 40px;
  margin-bottom: 40px;
}
.change-logintype {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.red-word {
  font-size: 14px;
  line-height: 20px;
  color: #f0386c;
  cursor: pointer;
  font-family: 'PingFang SC', sans-serif;
}
</style>
